module.exports = __webpack_public_path__ + "static/media/logo_harinera_ho.3d7674ab.jpg";